// RebarActiveCpInfo.js
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import styles from './CpInfo.module.css';
import Configuration from './TabPages/Configuration';
import { useTranslation } from 'react-i18next';
import { Accordion } from 'react-bootstrap';
import RebarCpPatterns from './TabPages/RebarCpPatterns';
import RebarCpSummary from './TabPages/RebarCpSummary';
import Statistics from './TabPages/RebarCpStatistics';
import RebarCpOtherInfo from './TabPages/RebarCpOtherInfo';
import RebarSolutionOptions from './TabPages/RebarSolutionOptions';
import './InfoAccordion.css';

const RebarActiveCpInfo = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('summary');

    return (
        <Container fluid className='flex'>
            <Row>
                <Col lg={2} className={styles.stickyConfiguration}>
                    <Accordion defaultActiveKey="selection">
                        <Accordion.Item eventKey="selection">
                            <Accordion.Header style={{margin: '0'}}>
                                <span className='fw-bold'>
                                    {t("Seçim")}
                                </span>
                            </Accordion.Header>
                            <Accordion.Body style={{fontSize: '0.9rem', padding: '0.5rem'}}>
                                <Configuration />
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="diameters">
                            <Accordion.Header style={{padding: '0'}}>
                                <span className='fw-bold'>
                                    {t("İstatistikler")}
                                </span>
                            </Accordion.Header>
                            <Accordion.Body style={{padding: '0.5rem'}}>
                                <Statistics />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Col>
                <Col lg={10}>
                    <Tab.Container fluid="md" id="left-tabs-example" defaultActiveKey="summary">
                        <Nav className="nav-tabs nav-fill flex-row">
                            <Col xs={3}>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="summary"
                                        className={activeTab === 'summary' ? styles.activeTab : styles.tabHeader}
                                        onClick={() => setActiveTab('summary')}
                                    >
                                        {t("Özet")}
                                    </Nav.Link>
                                </Nav.Item>
                            </Col>
                            <Col xs={3}>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="cuttingPlan"
                                        className={activeTab === 'cuttingPlan' ? styles.activeTab : styles.tabHeader}
                                        onClick={() => setActiveTab('cuttingPlan')}
                                    >
                                        {t("Kesim")}
                                    </Nav.Link>
                                </Nav.Item>
                            </Col>
                            <Col xs={3}>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="other"
                                        className={activeTab === 'other' ? styles.activeTab : styles.tabHeader}
                                        onClick={() => setActiveTab('other')}
                                    >
                                        {t("Diğer")}
                                    </Nav.Link>
                                </Nav.Item>
                            </Col>
                            <Col xs={3}>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="info"
                                        className={activeTab === 'info' ? styles.activeTab : styles.tabHeader}
                                        onClick={() => setActiveTab('info')}
                                    >
                                        {t("Bilgi")}
                                    </Nav.Link>
                                </Nav.Item>
                            </Col>
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey="summary" transition={false}>
                                <RebarCpSummary />
                            </Tab.Pane>
                            <Tab.Pane eventKey="cuttingPlan" transition={false}>
                                <RebarCpPatterns />
                            </Tab.Pane>
                            <Tab.Pane eventKey="other" transition={false}>
                                <RebarCpOtherInfo />
                            </Tab.Pane>
                            <Tab.Pane eventKey="info" transition={false}>
                                <RebarSolutionOptions />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Col>
            </Row>
        </Container>
    );
};

export default RebarActiveCpInfo;